import get from 'lodash/get';

import MessageFlowOption from './MessageFlowOption';

// These message flow skip reasons come from BE.
export const SKIP_REASON_DO_NOT_SKIP = 0;
export const SKIP_REASON_SKIP_FOR_STAFF = 1;
export const SKIP_REASON_REMOVED = 2;

const defaultProps = {
  /* The type of action performed by the automated message */
  action: null,
  /* Whether this message flow is completed */
  complete: false,
  /* Detail text for the message */
  detailText: '',
  /* The automated messages in this message flow */
  message: '',
  /* The name for the automated flow */
  messageOrder: 0,
  /* The type of the message */
  messageType: 1,
  /* The options for the automated message */
  options: [],
  /* The user or automated response for the message */
  response: [],
  /* The detailed sender id for the automated message */
  senderId: -1,
  /* The skip reason. */
  skipReason: SKIP_REASON_DO_NOT_SKIP
};

const convertInternal = (whMessageFlowMessage) => {
  return {
    action: whMessageFlowMessage.action || defaultProps.action,
    complete: whMessageFlowMessage.complete || defaultProps.complete,
    detailText: whMessageFlowMessage.detailText || defaultProps.detailText,
    message: whMessageFlowMessage.message || defaultProps.message,
    messageOrder: whMessageFlowMessage.messageOrder || defaultProps.messageOrder,
    messageType: whMessageFlowMessage.messageType || defaultProps.messageType,
    options: get(whMessageFlowMessage, 'options', []).map(option =>
      MessageFlowOption.createFromWarehouseResponse({
        whMessageFlowOption: option
      })) || defaultProps.options,
    response: whMessageFlowMessage.response || defaultProps.response,
    senderId: whMessageFlowMessage.senderId || defaultProps.senderId,
    skipReason: whMessageFlowMessage.skipReason || defaultProps.skipReason
  };
};

class MessageFlowMessage {
  /**
   * Creates a new MessageFlowMessage based on the server response
   * @argument whMessageFlow: server response message flow message
   */
  static createFromWarehouseResponse ({ whMessageFlowMessage }) {
    return new MessageFlowMessage({
      ...convertInternal(whMessageFlowMessage)
    });
  }

  /** Creates a new MessageFlowMessage
   * @argument fields: The attributes to add to this instance
   */
  constructor (fields = defaultProps) {
    Object.assign(this, fields);
  }

  /** Generates a copy of the MessageFlowMessage instance
   * @argument overrides: The attributes to add to the new instance
  */
  makeCopy (overrides) {
    return new MessageFlowMessage({
      action: this.action,
      complete: this.complete,
      detailText: this.detailText,
      message: this.message,
      messageOrder: this.messageOrder,
      messageType: this.messageType,
      options: [...this.options],
      response: [...this.response],
      senderId: this.senderId,
      skipReason: this.skipReason,
      ...overrides
    });
  }
}

export default MessageFlowMessage;
